angular.module('cfn').directive('cfnInputTime', [
  'timeFormatter',
  function(timeFormatter) {
    return {
      restrict: 'E',
      scope: {
        class: '@',
        readonly: '=',
        required: '@',
        change: '&',
        timemodel: '='
      },
      //replace: true,
      template:
        '<div class="time-picker-custom cfn-input-time">' +
        '<cfn-input-time-value mode="hh" class="cfn-input-time-value-left" model="timeValues.hh" ng-readonly="readonly" ng-required="{{required}}" maxlength="2"></cfn-input-time-value>' +
        '<div tabindex="-1"  class="seperator part" >:</div>' +
        '<cfn-input-time-value mode="mm" class="cfn-input-time-value-right" model="timeValues.mm" ng-readonly="readonly" ng-required="{{required}}" maxlength="2"></cfn-input-time-value>' +
        '</div>',
      link: function(scope, element) {
        // Grab Children
        let $timeValueHH = element.find('.hh');
        let $timeValueMM = element.find('.mm');

        init();

        function init() {
          // model Events
          scope.$watch('timemodel', updateChildModels);
          scope.$watch('timeValues.mm', updateParentModel);
          scope.$watch('timeValues.hh', updateParentModel);

          // child events
          scope.$on('userValueInputSeemsFinished', function(d1, timeValueMode) {
            if (timeValueMode === 'hh') selectMMInput();
          });

          // key Events (e.g. Arrow Key Press)
          $timeValueHH.keydown(selectMMInputIfNeccessary);
          $timeValueMM.keydown(selectMMInputIfNeccessary);

          // init child (time values hh and mm) scope
          scope.timeValues = {};
        }

        function updateChildModels(newVal, oldVal) {
          let hasNoValue = _(newVal).isUndefined() || _(newVal).isNull();
          if (!hasNoValue) {
            scope.timeValues.hh = parseInt(newVal.split(':')[0]);
            scope.timeValues.mm = parseInt(newVal.split(':')[1]);
          }
        }

        function updateParentModel() {
          let hasNoValueHH =
              _(scope.timeValues.hh).isUndefined() ||
              _(scope.timeValues.hh).isNull(),
            hasNoValueMM =
              _(scope.timeValues.mm).isUndefined() ||
              _(scope.timeValues.mm).isNull(),
            mm,
            hh;

          if (!hasNoValueHH && !hasNoValueMM) {
            hh = timeFormatter.hour.intToStr(scope.timeValues.hh);
            mm = timeFormatter.minute.intToStr(scope.timeValues.mm);
            scope.timemodel = hh + ':' + mm;
          }
        }

        function selectMMInputIfNeccessary(e) {
          let $this = $(this);
          let caretPos = $this[0].selectionEnd;

          // Right arrow (39)
          if (e.keyCode === 39 && caretPos === $this.val().length) {
            selectMMInput();
            e.preventDefault();
          }
        }

        function selectMMInput() {
          $timeValueMM.select();
        }
      }
    };
  }
]);
